import React, {useState} from 'react';
import {useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';
import MobilePopupModal from '../newPopup/mobilePopup/MobilePopupModal';
import {Button} from '@tickchak/react-share/app';
import * as css from './ExistingEmailPopup.css';
import setGlobalState from '../../redux/setGlobalState';
import RadioBtn from '../radioBtn/RadioBtn';
import {updatePhone} from '../../redux/user/userActions';
import {bounceMessage} from '../../layout/userMessages/UserMessage';

interface ExistingEmailPopupProps {
    close: () => void;
    showClass: string;
    onClearPhone: () => void;
}

type SelectedOption = 'useExisting' | 'contactSupport';

function ExistingEmailPopup({close, showClass, onClearPhone}: ExistingEmailPopupProps) {
    const {t} = useTranslation('login');
    const existingEmailData = useSelector((s: any) => s.ui.login.existingEmailData);
    const [selectedOption, setSelectedOption] = useState<SelectedOption>('useExisting');

    const {maskedEmail, maskedPhone, newPhone, user} = existingEmailData || {};

    const handleCancel = () => {
        close();
        setGlobalState('ui.login.existingEmailData', null);
        setGlobalState('user.getTokenToSignUpXHR', null);
    };

    const handleContinue = async () => {
        if(selectedOption === 'useExisting') {
            onClearPhone();
        } else {
            const res = await updatePhone(newPhone, user);
            if(res?.message) {
                bounceMessage(res.message, 'success');
            } 
        }
        close();
        setGlobalState('ui.login.existingEmailData', null);
        setGlobalState('user.getTokenToSignUpXHR', null);
    };

    return (
        <MobilePopupModal
            title={t('existingEmailTitle')}
            close={handleCancel}
            showClass={showClass}
            list={false}
            top={null}
            dataCyName="existingEmailPopup"
            cssStyle="max-width: 520px; height: auto; min-height: 350px;">
            <css.content>
                <css.message>
                    {t('existingEmailMessage', {maskedEmail, maskedPhone})}
                </css.message>
                <css.question>{t('existingEmailQuestion')}</css.question>
                <css.optionItem
                    onClick={() => setSelectedOption('useExisting')}
                    data-cy="existingEmailOption1">
                    <RadioBtn
                        selected={selectedOption === 'useExisting'}
                        onClick={() => setSelectedOption('useExisting')}
                        name="existingEmailOption1"
                    />
                    <css.optionText>{t('existingEmailOption1', {maskedPhone})}</css.optionText>
                </css.optionItem>
                <css.optionItem
                    onClick={() => setSelectedOption('contactSupport')}
                    data-cy="existingEmailOption2">
                    <RadioBtn
                        selected={selectedOption === 'contactSupport'}
                        onClick={() => setSelectedOption('contactSupport')}
                        name="existingEmailOption2"
                    />
                    <css.optionText>{t('existingEmailOption2')}</css.optionText>
                </css.optionItem>
                <css.buttonsWrapper>
                    <Button
                        variant="brand"
                        size="category"
                        onClick={handleContinue}
                        data-cy="existingEmailPopupContinueButton">
                        {t('existingEmailContinueButton')}
                    </Button>
                    <Button
                        variant="neutral"
                        size="category"
                        onClick={handleCancel}
                        data-cy="existingEmailPopupCancelButton">
                        {t('existingEmailCancelButton')}
                    </Button>
                </css.buttonsWrapper>
            </css.content>
        </MobilePopupModal>
    );
}

export default ExistingEmailPopup;
